import PipelineBoardPage from '../../../components/admin/pipeline/PipelineBoardPage'
export default function PipelineBoard() { return <PipelineBoardPage /> }
